export default __webpack_public_path__ + "static/media/lunch-club.41efd679.svg";